export default __webpack_public_path__ + "static/media/advance.55c981df.jpg";